import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import React, { PropsWithChildren, useContext } from "react";
import useBulkEditBotsForm from "@shared/features/bots/BotForm/common/hooks/useBulkEditBotsForm";

const BulkEditBotsValuesProvider = ({ children }: PropsWithChildren) => {
  const botFormContextValues = useContext(BotFormContext)!;
  const bulkEditBotsFormData = useBulkEditBotsForm();

  return (
    <BotFormContext.Provider
      value={{
        ...botFormContextValues,
        ...bulkEditBotsFormData,
        tabToRestoreChangesData: bulkEditBotsFormData.tabToRestoreChangesData,
      }}
    >
      {children}
    </BotFormContext.Provider>
  );
};

export default BulkEditBotsValuesProvider;
